import axios from '@/http'

export const apiTalentsMess = {
  // 获取人才详情信息
  getTalentsData: (id) => axios.get(`/api/talent/home/${id}`),
  getConstructionData: (id) => axios.get(`/api/team/${id}`),
  getTeamDetail: (id) => axios.get(`/api/team/detail/${id}`),
  getTeamType: (id) => axios.get(`/api/team/type/${id}`),
  getPersonDetailType: (id) => axios.get(`/talent/type/${id}`)

  // /api/team/{id}
}
